
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n322Child = []
  var n323Child = []
  var n324Child = []
  n324Child = n324Child.concat(text(t('.play_method')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n324 = h('label', props, n324Child)
  n323Child.push(n324)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n323 = h('div', props, n323Child)
  n322Child.push(n323)
  var n325Child = []
  var n326Child = []
  var n327Child = []
  var n328Child = []
  var n329Child = []
  n329Child = n329Child.concat(text(t('.method_update')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "update"},{name:'selected', val: (shadow.method != "replace")}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n329 = h('option', props, n329Child)
  n328Child.push(n329)
  var n330Child = []
  n330Child = n330Child.concat(text(t('.method_replace')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "replace"},{name:'selected', val: (shadow.method == "replace")}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n330 = h('option', props, n330Child)
  n328Child.push(n330)
  var props = {attributes: runtime.compileAttrs([{name:'name', val: "method"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n328 = h('select', props, n328Child)
  n327Child.push(n328)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n327 = h('div', props, n327Child)
  n326Child.push(n327)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n326 = h('div', props, n326Child)
  n325Child.push(n326)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n325 = h('div', props, n325Child)
  n322Child.push(n325)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n322 = h('div', props, n322Child)
  n0Child.push(n322)
  var v331 = shadow.tracks
  Object.keys(v331).forEach(function (index) {
    var track = v331[index]
    var n332Child = []
    var n333Child = []
    n333Child = n333Child.concat(text(t('.delete_track')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'class', val: 'is-danger'},{name:'type', val: "button"},{name:'onclick', val: this.deleteTrack.bind(this, track)}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n333 = h('button', props, n333Child)
    n332Child.push(n333)
    var n334Child = []
    var n335Child = []
    var n336Child = []
    n336Child = n336Child.concat(text(t('.source')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n336 = h('label', props, n336Child)
    n335Child.push(n336)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n335 = h('div', props, n335Child)
    n334Child.push(n335)
    var n337Child = []
    var n338Child = []
    var n339Child = []
    var n340Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][assetId]`},{name:'value', val: track.assetId}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n340 = h('input', props, n340Child)
    n339Child.push(n340)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n339 = h('div', props, n339Child)
    n338Child.push(n339)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n338 = h('div', props, n338Child)
    n337Child.push(n338)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n337 = h('div', props, n337Child)
    n334Child.push(n337)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n334 = h('div', props, n334Child)
    n332Child.push(n334)
    var n341Child = []
    var n342Child = []
    var n343Child = []
    n343Child = n343Child.concat(text(t('.instance_id')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n343 = h('label', props, n343Child)
    n342Child.push(n343)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n342 = h('div', props, n342Child)
    n341Child.push(n342)
    var n344Child = []
    var n345Child = []
    var n346Child = []
    var n347Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][instanceId]`},{name:'value', val: track.instanceId}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n347 = h('input', props, n347Child)
    n346Child.push(n347)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n346 = h('div', props, n346Child)
    n345Child.push(n346)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n345 = h('div', props, n345Child)
    n344Child.push(n345)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n344 = h('div', props, n344Child)
    n341Child.push(n344)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n341 = h('div', props, n341Child)
    n332Child.push(n341)
    var n348Child = []
    var n349Child = []
    var n350Child = []
    n350Child = n350Child.concat(text(t('.repeat')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n350 = h('label', props, n350Child)
    n349Child.push(n350)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n349 = h('div', props, n349Child)
    n348Child.push(n349)
    var n351Child = []
    var n352Child = []
    var n353Child = []
    if(track.repeat == -1) {
      var n354Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: null},{name:'type', val: "text"},{name:'value', val: t('.infinite')},{name:'readonly', val: true}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n354 = h('input', props, n354Child)
      n353Child.push(n354)
    } else {
      var n355Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][repeat]`},{name:'value', val: track.repeat},{name:'type', val: "number"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n355 = h('input', props, n355Child)
      n353Child.push(n355)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n353 = h('div', props, n353Child)
    n352Child.push(n353)
    var n356Child = []
    if(track.repeat == -1) {
      var n357Child = []
      n357Child = n357Child.concat(text(t('.set_times')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-primary'},{name:'onclick', val: this.setTrackRepeat.bind(this, track, 1)}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n357 = h('a', props, n357Child)
      n356Child.push(n357)
    } else {
      var n358Child = []
      n358Child = n358Child.concat(text(t('.set_infinite')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-danger'},{name:'onclick', val: this.setTrackRepeat.bind(this, track, -1)}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n358 = h('a', props, n358Child)
      n356Child.push(n358)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n356 = h('div', props, n356Child)
    n352Child.push(n356)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'has-addons'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n352 = h('div', props, n352Child)
    n351Child.push(n352)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n351 = h('div', props, n351Child)
    n348Child.push(n351)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n348 = h('div', props, n348Child)
    n332Child.push(n348)
    var n359Child = []
    var n360Child = []
    var n361Child = []
    n361Child = n361Child.concat(text(t('.volume')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n361 = h('label', props, n361Child)
    n360Child.push(n361)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n360 = h('div', props, n360Child)
    n359Child.push(n360)
    var n362Child = []
    var n363Child = []
    if('volume' in track) {
      var n364Child = []
      n364Child = n364Child.concat(text(t('.no_volume_change')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'onclick', val: futureMerge(track, { volume: UNSET })}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n364 = h('a', props, n364Child)
      n363Child.push(n364)
      var n365Child = []
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n365 = h('br', props, n365Child)
      n363Child.push(n365)
      if(typeof track.volume == "object") {
        var n366Child = []
        n366Child = n366Child.concat(text(t('.set_fixed_volume')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'type', val: "button"},{name:'onclick', val: futureMerge(track, {volume: 1})}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n366 = h('button', props, n366Child)
        n363Child.push(n366)
      } else {
        var n367Child = []
        n367Child = n367Child.concat(text(t('.set_gps_volume')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'type', val: "button"},{name:'onclick', val: futureMerge(track, {volume: {}})}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n367 = h('button', props, n367Child)
        n363Child.push(n367)
      }
    } else {
      var n368Child = []
      n368Child = n368Child.concat(text(t('.set_volume')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'onclick', val: futureMerge(track, { volume: 1 })}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n368 = h('a', props, n368Child)
      n363Child.push(n368)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'},{name:'key', val: "buttons"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n363 = h('div', props, n363Child)
    n362Child.push(n363)
    var n369Child = []
    if(typeof track.volume == "object") {
      var n370Child = []
      var n371Child = []
      var n372Child = []
      n372Child = n372Child.concat(text(t('.gps_longitude')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n372 = h('label', props, n372Child)
      n371Child.push(n372)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n371 = h('div', props, n371Child)
      n370Child.push(n371)
      var n373Child = []
      var n374Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][volume][longitude]`},{name:'value', val: track.volume.longitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n374 = h('input', props, n374Child)
      n373Child.push(n374)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n373 = h('div', props, n373Child)
      n370Child.push(n373)
      var n375Child = []
      var n376Child = []
      n376Child = n376Child.concat(text(t('.gps_latitude')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n376 = h('label', props, n376Child)
      n375Child.push(n376)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n375 = h('div', props, n375Child)
      n370Child.push(n375)
      var n377Child = []
      var n378Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][volume][latitude]`},{name:'value', val: track.volume.latitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n378 = h('input', props, n378Child)
      n377Child.push(n378)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n377 = h('div', props, n377Child)
      n370Child.push(n377)
      var n379Child = []
      var n380Child = []
      n380Child = n380Child.concat(text(t('.gps_distance_volume')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n380 = h('label', props, n380Child)
      n379Child.push(n380)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n379 = h('div', props, n379Child)
      n370Child.push(n379)
      var n381Child = []
      var n382Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'textarea'},{name:'name', val: `tracks[${index}][volume][distanceVolumes]`},{name:'value', val: track.volume.distanceVolumes}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n382 = h('textarea', props, n382Child)
      n381Child.push(n382)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n381 = h('div', props, n381Child)
      n370Child.push(n381)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n370 = h('div', props, n370Child)
      n369Child.push(n370)
    } else {
      if('volume' in track) {
        var n383Child = []
        var n384Child = []
        var n385Child = []
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][volume]`},{name:'value', val: track.volume},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n385 = h('input', props, n385Child)
        n384Child.push(n385)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n384 = h('div', props, n384Child)
        n383Child.push(n384)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n383 = h('div', props, n383Child)
        n369Child.push(n383)
      }
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'},{name:'key', val: "setting"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n369 = h('div', props, n369Child)
    n362Child.push(n369)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n362 = h('div', props, n362Child)
    n359Child.push(n362)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n359 = h('div', props, n359Child)
    n332Child.push(n359)
    var n386Child = []
    var n387Child = []
    var n388Child = []
    n388Child = n388Child.concat(text(t('.fade_seconds')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n388 = h('label', props, n388Child)
    n387Child.push(n388)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n387 = h('div', props, n387Child)
    n386Child.push(n387)
    var n389Child = []
    var n390Child = []
    var n391Child = []
    var n392Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][volumeChangeSeconds]`},{name:'value', val: track.volumeChangeSeconds},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n392 = h('input', props, n392Child)
    n391Child.push(n392)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n391 = h('div', props, n391Child)
    n390Child.push(n391)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n390 = h('div', props, n390Child)
    n389Child.push(n390)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n389 = h('div', props, n389Child)
    n386Child.push(n389)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n386 = h('div', props, n386Child)
    n332Child.push(n386)
    var n393Child = []
    var n394Child = []
    var n395Child = []
    n395Child = n395Child.concat(text(t('.playback_state')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n395 = h('label', props, n395Child)
    n394Child.push(n395)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n394 = h('div', props, n394Child)
    n393Child.push(n394)
    var n396Child = []
    var n397Child = []
    var n398Child = []
    if('pause' in track) {
      var n399Child = []
      n399Child = n399Child.concat(text(t('.no_pause_change')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'onclick', val: futureMerge(track, { pause: UNSET })}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n399 = h('a', props, n399Child)
      n398Child.push(n399)
      var n400Child = []
      var n401Child = []
      n401Child.push(text("= t('.pause')"))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'checkbox'},{name:'name', val: `tracks[${index}][pause]`},{name:'value', val: "true"},{name:'checked', val: track.pause},{name:'type', val: "checkbox"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n401 = h('input', props, n401Child)
      n400Child.push(n401)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'checkbox'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n400 = h('label', props, n400Child)
      n398Child.push(n400)
    } else {
      var n402Child = []
      n402Child = n402Child.concat(text(t('.change_pause')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'onclick', val: futureMerge(track, { pause: true })}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n402 = h('a', props, n402Child)
      n398Child.push(n402)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n398 = h('div', props, n398Child)
    n397Child.push(n398)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n397 = h('div', props, n397Child)
    n396Child.push(n397)
    var n403Child = []
    var n404Child = []
    var n405Child = []
    n405Child = n405Child.concat(text(t('.play_position')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n405 = h('p', props, n405Child)
    n404Child.push(n405)
    var n406Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][currentTime]`},{name:'value', val: track.currentTime},{name:'placeholder', val: t('.placeholder_no_change')},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n406 = h('input', props, n406Child)
    n404Child.push(n406)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n404 = h('div', props, n404Child)
    n403Child.push(n404)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n403 = h('div', props, n403Child)
    n396Child.push(n403)
    var n407Child = []
    var n408Child = []
    var n409Child = []
    n409Child = n409Child.concat(text(t('.stop_position')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n409 = h('p', props, n409Child)
    n408Child.push(n409)
    var n410Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `tracks[${index}][stopTime]`},{name:'value', val: track.stopTime},{name:'placeholder', val: t('.placeholder_no_change')},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n410 = h('input', props, n410Child)
    n408Child.push(n410)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n408 = h('div', props, n408Child)
    n407Child.push(n408)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n407 = h('div', props, n407Child)
    n396Child.push(n407)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n396 = h('div', props, n396Child)
    n393Child.push(n396)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n393 = h('div', props, n393Child)
    n332Child.push(n393)
    var n411Child = []
    var n412Child = []
    var n413Child = []
    n413Child = n413Child.concat(text(t('.fade')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n413 = h('label', props, n413Child)
    n412Child.push(n413)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n412 = h('div', props, n412Child)
    n411Child.push(n412)
    var n414Child = []
    var n415Child = []
    var n416Child = []
    var n417Child = []
    n417Child = n417Child.concat(text(t('.fade_in_seconds')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-static'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n417 = h('div', props, n417Child)
    n416Child.push(n417)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n416 = h('div', props, n416Child)
    n415Child.push(n416)
    var n418Child = []
    var n419Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "number"},{name:'name', val: `tracks[${index}][fadeInSeconds]`},{name:'value', val: track.fadeInSeconds},{name:'placeholder', val: t('.placeholder_no_change')},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n419 = h('input', props, n419Child)
    n418Child.push(n419)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n418 = h('div', props, n418Child)
    n415Child.push(n418)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'has-addons'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n415 = h('div', props, n415Child)
    n414Child.push(n415)
    var n420Child = []
    var n421Child = []
    var n422Child = []
    n422Child = n422Child.concat(text(t('.fade_out_seconds')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-static'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n422 = h('div', props, n422Child)
    n421Child.push(n422)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n421 = h('div', props, n421Child)
    n420Child.push(n421)
    var n423Child = []
    var n424Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "number"},{name:'name', val: `tracks[${index}][fadeOutSeconds]`},{name:'value', val: track.fadeOutSeconds},{name:'placeholder', val: t('.placeholder_no_change')},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n424 = h('input', props, n424Child)
    n423Child.push(n424)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n423 = h('div', props, n423Child)
    n420Child.push(n423)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'has-addons'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n420 = h('div', props, n420Child)
    n414Child.push(n420)
    var n425Child = []
    var n426Child = []
    var n427Child = []
    n427Child = n427Child.concat(text(t('.fade_min_volume')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-static'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n427 = h('div', props, n427Child)
    n426Child.push(n427)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n426 = h('div', props, n426Child)
    n425Child.push(n426)
    var n428Child = []
    var n429Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "number"},{name:'name', val: `tracks[${index}][fadeMinVolume]`},{name:'value', val: track.fadeMinVolume},{name:'placeholder', val: t('.placeholder_no_change')},{name:'step', val: "0.01"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n429 = h('input', props, n429Child)
    n428Child.push(n429)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n428 = h('div', props, n428Child)
    n425Child.push(n428)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'has-addons'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n425 = h('div', props, n425Child)
    n414Child.push(n425)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n414 = h('div', props, n414Child)
    n411Child.push(n414)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n411 = h('div', props, n411Child)
    n332Child.push(n411)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'box'},{name:'key', val: track}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n332 = h('div', props, n332Child)
    n0Child.push(n332)
  }.bind(this))
  var n430Child = []
  var n431Child = []
  var n432Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-plus'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n432 = h('i', props, n432Child)
  n431Child.push(n432)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n431 = h('span', props, n431Child)
  n430Child.push(n431)
  var n433Child = []
  n433Child = n433Child.concat(text(t('.add_track')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n433 = h('span', props, n433Child)
  n430Child.push(n433)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-primary'},{name:'onclick', val: this.addTrack},{name:'type', val: "button"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n430 = h('button', props, n430Child)
  n0Child.push(n430)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  